import React from "react";
import DealScore from "../../deal-score";
import StringProcessingService from "../../../services/string-processing-service";
import DealScoreContactForm from "./deal-score-contact-form";

import ListingSlider from "../../listing-slider";
import '../../../lib/slick-1.8.1/slick.css';
import '../../../lib/slick-1.8.1/slick-theme.css';

import '../listing-page-style.css';


export default function ListingMedia(props) {

    const {
        dictionary,
        width,
        height,
        analyseInfo,
        agent,
        handleDealScore,
        country,
        contactInfo,
        selectedCountry,
        saveCurrentSelectedCountry,
        handleInput,
        clearForm,
        openThanksModal,
        handleSwitchMedia,
        currentImgId,
        currentImg,
        data,
        disableModal = false,
    } = props;
    
    
    const renderMediaSwitch = () => {

        let moreImg = require('../../../elements/images/more_image.png')
        return (
            <div className="MediaSwitchDiv">{data.Media.map((item, index) => {
                if (currentImgId === item.Order && index < 4) {
                    return (
                        <div key={index}>
                            <div className="MediaSwitchItem" onClick={handleSwitchMedia.bind(this, item)}>
                                <img src={item.MediaUrl} className="MediaImgSmall" alt="" ></img>
                            </div>
                        </div>
                    )
                } else if (index < 4) {
                    return (
                        <div key={index}>
                            <div className="MediaSwitchItem" onClick={handleSwitchMedia.bind(this, item)}>
                                <img src={item.MediaUrl} className="MediaImgSmall" alt="" ></img>
                                <div className="Other"></div>
                            </div>
                        </div>
                    )
                } else if (index === 5) {
                    return (
                        <div key={index}>
                            <div className="MediaSwitchItem">
                                <img src={moreImg} className="MediaImgSmall" alt="" ></img>
                            </div>
                        </div>
                    )
                }

            })}</div>
        )

    }

    const renderMedia = () => {
        if (data.Media.length <= 4) {
            return (
                <div className={"PropImages"}>
                    <div className="MediaCurrentDiv">
                        <img className="MediaImgBig" src={currentImg} alt=""></img>
                    </div>
                    {renderMediaSwitch()}
                </div>
            )
        } else {
            return (
                <div>
                    <ListingSlider
                        country={country}
                        data={data}
                        analyseInfo={analyseInfo}
                        dictionary={dictionary}
                        width={width}
                        height={height}
                        disableModal = {disableModal}
                    />
                </div>
            )
        }

    }
   


    return (
        <div className="MediaMain" >
            <div className="MediaBlock">
                {renderMedia()}
            </div>
            <div className="DealScoreAndContacts" id={agent ? 'AgentContact' : ''}>
                <DealScore
                    dictionary={dictionary}
                    width={width}
                    analyseInfo={analyseInfo}
                    handleDealScore={handleDealScore}
                />
                <DealScoreContactForm
                    dictionary={dictionary}
                    width={width}
                    country={country}
                    contactInfo={contactInfo}
                    selectedCountry={selectedCountry}
                    agent={agent}
                    analyseInfo={analyseInfo}
                    data={data}
                    saveCurrentSelectedCountry={saveCurrentSelectedCountry}
                    handleInput={handleInput}
                    clearForm={clearForm}
                    openThanksModal={openThanksModal}
                />
            </div>
        </div>
    )
}